// Blocked personal email domains
const BLOCKED_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.ca',
  'yahoo.fr',
  'yahoo.de',
  'ymail.com',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'aim.com',
  'protonmail.com',
  'proton.me',
  'mail.com',
  'gmx.com',
  'gmx.net',
  'zoho.com',
  'yandex.com',
  'mail.ru',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'rediffmail.com',
  'naver.com',
  'hanmail.net',
  'daum.net',
];

export const isCompanyEmail = (email: string): boolean => {
  const domain = email.toLowerCase().split('@')[1];
  return !BLOCKED_DOMAINS.includes(domain);
};

export const getEmailDomain = (email: string): string => {
  return email.toLowerCase().split('@')[1] || '';
};

export const validateEmail = (email: string): { isValid: boolean; error?: string } => {
  // Basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }

  // Check if it's a company email
  if (!isCompanyEmail(email)) {
    return {
      isValid: false,
      error: `Personal email addresses are not allowed. Please use your company email address.`,
    };
  }

  return { isValid: true };
};
